import { createFileRoute } from "@tanstack/react-router"
import { useGetUserAuthenticationFactors } from "@/routes/-components/user-authentication-factor/use-get-user-authentication-factors"
import { ValidateAuthenticationFactorStack } from "@/routes/-components/user-authentication-factor/validate-authentication-factor-stack"
import { useGetAuthenticatedUser } from "@/routes/app/-components/use-authenticated-user"
import { useQueryClient } from "@tanstack/react-query"
import { useTranslation } from "react-i18next"
import { AuthContainer } from "../../-components/auth-container"

export const Route = createFileRoute("/authenticate/mfa/$id/validate")({
  component: ValidateTotp,
  validateSearch: (search: { returnUrl?: string }) => {
    return {
      returnUrl: search.returnUrl,
    }
  },
})

export function ValidateTotp() {
  const search = Route.useSearch()
  const userAuthenticationFactorId = parseInt(Route.useParams().id)
  const { data: authenticatedUser } = useGetAuthenticatedUser()
  const { data: userAuthenticationFactors } = useGetUserAuthenticationFactors({
    userId: authenticatedUser.userId,
    includeInactive: false,
    includeUnvalidated: false,
    includeNotAllowedAuthenticationTypes: false,
  })
  const navigate = Route.useNavigate()
  const queryClient = useQueryClient()
  const { t } = useTranslation("app_server")

  return (
    <AuthContainer title={t("Login")}>
      <ValidateAuthenticationFactorStack
        userAuthenticationFactorId={userAuthenticationFactorId}
        onSuccess={() => {
          queryClient.clear()
          navigate({ to: "/app" })
        }}
        onCancel={() => {
          if (userAuthenticationFactors.length > 1) {
            navigate({
              to: "/authenticate/mfa/select-authentication-factor",
              search: { returnUrl: search.returnUrl },
            })
          } else {
            navigate({
              to: "/authenticate/login",
              search: { returnUrl: search.returnUrl },
            })
          }
        }}
      />
    </AuthContainer>
  )
}
